import { Box, Chip, FormControl, Grid, InputLabel, OutlinedInput, Select } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import { useMemo } from "react";
import { FormattedMessage, useIntl } from 'react-intl';
import { useLanguage } from "../hooks/useLanguage";
import { getDefaultLanguage } from "../utils/lib";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function AttributeRegionSelection({ updateDefaults, updateValidation, validation, defaults, baseSelection }) {

  const intl = useIntl();

  const { locale } = useLanguage();

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    updateValidation({ values: value.map(v => v.id) });
  };

  // all base-values
  const baseValues = useMemo(() => {
    if (baseSelection?.values) {
      return baseSelection.values;
    } else {
      return [];
    }
  }, [baseSelection]);

  // all selection-values
  const selectedValues = useMemo(() => {
    let filter = validation?.values ?? [];
    return baseValues.filter(v => filter.includes(v.id));
  }, [validation, baseValues]);

  // the default-value (is one of the objects from values, since those include ids)
  const defaultValue = useMemo(() => {
    if (defaults?.value) {
      for (let value of selectedValues) {
        if (value.id === defaults.value) {
          return value;
        }
      }
    }
  }, [defaults, selectedValues]);

  return (
    <Grid container item xs={12} spacing={1} >

      <Grid item container xs={12} sm={6} md={3} spacing={1}>
        <FormControl sx={{ m: 1, width: 300 }}>
          <InputLabel id="demo-multiple-chip-label"><FormattedMessage id="EditAttribute.values" /></InputLabel>
          <Select
            labelId="demo-multiple-chip-label"
            id="demo-multiple-chip"
            multiple
            value={selectedValues}
            onChange={handleChange}
            input={<OutlinedInput id="select-multiple-chip" label={intl.formatMessage({ id: "EditAttribute.values" })} />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip key={value.id} label={getDefaultLanguage(value, locale)} />
                ))}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {baseValues.map((v) => (
              <MenuItem
                key={v.id}
                value={v}
              >
                {getDefaultLanguage(v, locale)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      {
        selectedValues.length > 0 && <Grid item xs={12} sm={6} md={3} >
          <FormControl variant="outlined" sx={{ width: '90%' }} >
            <InputLabel id="selected-value-label" ><FormattedMessage id="EditAttribute.defaultValue" /></InputLabel>
            <Select
              labelId="selected-value-label"
              value={defaultValue || ''}
              onChange={event => updateDefaults({ value: event.target.value.id || null })}
              label={<FormattedMessage id="EditAttribute.defaultValue" />}
            >
              <MenuItem value={''}><FormattedMessage id="EditAttribute.noDefaultValue" /></MenuItem>
              {
                selectedValues && selectedValues.map((choice, index) => <MenuItem key={index} value={choice} >{getDefaultLanguage(choice, locale)}</MenuItem>)
              }
            </Select>
          </FormControl>
        </Grid>
      }
    </Grid>
  )
}